import { render } from "./Dividends.vue?vue&type=template&id=9402ddce&scoped=true"
import script from "./Dividends.vue?vue&type=script&lang=js"
export * from "./Dividends.vue?vue&type=script&lang=js"

import "./Dividends.vue?vue&type=style&index=0&id=9402ddce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9402ddce"]])

export default __exports__